


























import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'

settings =
  name: 'NetworkOverviewStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
    }

export default VueOptions.vue settings
